import { getGoogleAttributeNameByLanguage } from '~/utils'

export const getGroupName = (AttributeObject, attributeName, lang) =>
  AttributeObject[getGoogleAttributeNameByLanguage(lang, attributeName)] ||
  AttributeObject[attributeName]

export const getAttibuteName = (AttributeObject, attributeName, lang) =>
  AttributeObject[getGoogleAttributeNameByLanguage(lang, attributeName)] ||
  AttributeObject[attributeName]

export const isAttributeEnabled = (attribute) => {
  if (attribute.valueType === 'REPEATED_ENUM') {
    const values =
      attribute?.repeatedEnumValue?.setValues || attribute?.repeatedEnumValue?.unsetValues || []
    return values.length > 0
  }
  if (attribute.valueType === 'URL') return attribute.uriValues.length > 0

  return !!attribute?.values[0]?.value
}
